import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "../Pages/Home";
import Login from "../Pages/Login";
import PageNotFound from "../Pages/PageNotFound";
import ContactUs from "../Pages/ContactUs";
import Audio from "../Pages/Audio";
import Cameras from "../Pages/Cameras";
// import CheckOut from "../Pages/CheckOut";
import Cart from "../Pages/Cart";
import HomeAppliances from "../Pages/HomeAppliances";
import KitchenAppliances from "../Pages/KitchenAppliances";
import MobileandTablet from "../Pages/MobileandTablet";
import PersonalCare from "../Pages/PersonalCare";
import SignUp from "../Pages/SignUp";
import Televisions from "../Pages/Televisions";
import SingleProduct from "../Pages/SingleProduct";
import Accessories from "../Pages/Accessories";
import AllProducts from "../Pages/AllProducts";
import CheckOut from "../Pages/CheckOut";
import PrivateRoutes from "./PrivateRoutes";
// <PrivateRoutes><Televisions /></PrivateRoutes>
import Computers from "../Pages/Computers";

function AllRoutes() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route
          path="/mobileandtablet"
          element={
            <PrivateRoutes>
              <MobileandTablet />
            </PrivateRoutes>
          }
        />
        <Route
          path="/televisions"
          element={
            <PrivateRoutes>
              <Televisions />
            </PrivateRoutes>
          }
        />
        <Route
          path="/audio"
          element={
            <PrivateRoutes>
              <Audio />
            </PrivateRoutes>
          }
        />
        <Route
          path="/homeappliances"
          element={
            <PrivateRoutes>
              <HomeAppliances />
            </PrivateRoutes>
          }
        />
        <Route
          path="/computers"
          element={
            <PrivateRoutes>
              <Computers />
            </PrivateRoutes>
          }
        />

        <Route
          path="/checkout"
          element={
            <PrivateRoutes>
              <CheckOut />
            </PrivateRoutes>
          }
        />

        <Route
          path="/cameras"
          element={
            <PrivateRoutes>
              <Cameras />
            </PrivateRoutes>
          }
        />
        <Route
          path="/kitchenappliances"
          element={
            <PrivateRoutes>
              <KitchenAppliances />
            </PrivateRoutes>
          }
        />
        <Route
          path="/personalcare"
          element={
            <PrivateRoutes>
              <PersonalCare />
            </PrivateRoutes>
          }
        />
        <Route
          path="/accessories"
          element={
            <PrivateRoutes>
              <Accessories />
            </PrivateRoutes>
          }
        />
        <Route
          path="/cart"
          element={
            <PrivateRoutes>
              <Cart />
            </PrivateRoutes>
          }
        />
        <Route
          path="/computers/:PID"
          element={
            <PrivateRoutes>
              <SingleProduct />
            </PrivateRoutes>
          }
        />
        <Route
          path="/allprodcucts"
          element={
            <PrivateRoutes>
              <AllProducts />
            </PrivateRoutes>
          }
        />

        <Route path="/*" element={<PageNotFound />} />
      </Routes>
    </>
  );
}

export default AllRoutes;
